import React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "./constants";
import firebase from 'firebase/app';
import "firebase/auth";
import md5 from "blueimp-md5";
import { ClipLoader } from 'react-spinners';

export default class SignUpView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: undefined,
            displayName: undefined,
            password: undefined,
            confirmPassword: undefined,
            loading: false,
        }
    }
    componentDidMount() {
        this.authUnListen = firebase.auth().onAuthStateChanged(user => {
            if (user) {
                this.props.history.push(ROUTES.generalChannel);
            }
        });
    }

    componentWillUnmount() {
        this.authUnListen();
    }
    handleSubmit(evt) {
        evt.preventDefault();
        let photoUrlHash = md5(this.state.email.toLowerCase().trim());
        this.setState({ loading: true });
        firebase.auth().createUserWithEmailAndPassword(this.state.email, this.state.password)
            .then(user => user.updateProfile({
                displayName: this.state.displayName,
                photoURL: `https://www.gravatar.com/avatar/${photoUrlHash}`,
            }))
            .then(() => this.props.history.push(ROUTES.generalChannel))
            .catch(err => this.setState({ fberror: err }))
            .then(() => this.setState({ loading: false }))
    }

    render() {
        let errorMessage = this.state.confirmPassword ? (this.state.password !== this.state.confirmPassword ? 'Passwords dont\'t match' : this.state.fberror ? this.state.fberror.message : undefined) : undefined;
        return (
            <div>
                {this.state.loading
                    ?
                    <div className='sweet-loading'>
                        <ClipLoader
                            color={'red'}
                            size={100}
                            loading={this.state.loading}
                        />
                    </div>
                    :
                    <div>
                        <header className="jumbotron jumbotron-fluid bg-success text-white">
                            <div className="container">
                                <h1>Sign Up</h1>
                            </div>
                        </header>
                        <main>
                            <div className="container">
                                {
                                    errorMessage ?
                                        <div className="alert alert-danger">
                                            {errorMessage}
                                        </div> :
                                        undefined
                                }
                                <form onSubmit={evt => this.handleSubmit(evt)}>
                                    <div className="form-group">
                                        <label htmlFor="email">Email Address</label>
                                        <input type="text"
                                            id="email"
                                            className="form-control"
                                            placeholder="your email address"
                                            onInput={(evt) => this.setState({ email: evt.target.value })}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="name">Display Name</label>
                                        <input type="text"
                                            id="name"
                                            className="form-control"
                                            placeholder="your display name"
                                            onInput={(evt) => this.setState({ displayName: evt.target.value })}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="password">Password</label>
                                        <input type="password"
                                            id="password"
                                            className="form-control"
                                            placeholder="your password"
                                            onInput={(evt) => this.setState({ password: evt.target.value })}
                                            minLength={6}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="confirm">Confirm Password</label>
                                        <input type="password"
                                            id="confirm"
                                            className="form-control"
                                            placeholder="confirm your password"
                                            onInput={(evt) => this.setState({ confirmPassword: evt.target.value })}
                                            minLength={6}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <button type="submit" className="btn btn-success">Sign Up</button>
                                    </div>
                                </form>
                                <p>Already have an account? <Link to={ROUTES.signIn}>Sign In!</Link></p>
                            </div>
                        </main>
                    </div>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/SignUp.js